
import { req, reqfile } from './axiosFun';

// 登录人数
export const proNum = () => { return req("get", "/lx/visitor_count", ) };
export const addproNum = () => { return req("post", "/lx/visitor_count", ) };
// 登录接口 
export const login = (params) => { return req("post", "/login", params) };

// 学校 
export const schoollist = (params) => { return req("get", "/school_list", params) };
export const schoocreate = (params) => { return req("post", "/school_create", params) };
export const schooldelete = (params) => { return req("delete", `/school_delete?schoolId=${params}`,) };
export const schooledit = (params) => { return req("PATCH", `/school_edit`, params) };


// 班级
export const classlist = (params) => { return req("get", "/class_list", params) };
export const classcreate = (params) => { return req("post", "/class_create", params) };
export const classedit = (id, params) => { return req("PATCH", "/class_edit?classId=" + id, params) };
export const classdelete = (params) => { return req("delete", `/class_delete?classId=${params}`) };
export const classinfo = (params) => { return req("get", "/class_info", { params }) };

// 账号
export const accountlist = (params) => { return req("get", `/account_list?classId=${params}`) };
export const accountinfo = (params) => { return req("get", `/account_info?id=${params}`) };
export const accountcreate = (params) => { return req("post", "/account_create", params) };
export const importuser = (params) => { return req("post", "/import", params) };
export const accountedit = (id, params) => { return req("PATCH", `/account_edit?id=` + id, params) };
export const accountdelete = (params) => { return req("delete", `/account_delete?id=${params}`) };
export const myinfos = () => { return req("get", `/account_info`) };
export const myedit = (params) => { return req("PATCH", `/account_edit_self`, params) };
export const getsaist = (params) => { return req("get", `/admin/sa_list?schoolId=` + params) };
export const getTeacher = () => { return req("get", `/sa/teacher_list`) };
// 实验
export const labedit = (params,id) => { return req("path", `/lab_edit?labId=${id}`,params) };
export const labcreate = (params) => { return req("post", `/lab_create`,params) };
export const labdelete = (params) => { return req("delete", `/lab_delete?labId=${params}`,) };
export const lablist = () => { return req("get", `/lab_list`) };
export const scorequeryself = (id) => { return req("get", `/score_query_self?labId=${id}`) };
export const scorequeryclass = (params) => { return req("get", `/score_query_class?labId=${params.labId}&classId=${params.classId}`) };
export const scorequeryaccount = (params) => { return req("get", `/score_query_account?labId=${params.labId}&accountId=${params.accountId}`) };
export const scorequeryclassxlsx = (params) => { return reqfile("get", `/score_query_class_xlsx?labId=${params.labId}&classId=${params.classId}`) };
export const scoreedit = (params) => { return req("PATCH", `/score_edit?labId=${params.labId}&accountId=${params.accountId}`, params) };






// WEBPACK FOOTER //
// ./src/api/userMG.js